import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import AppContext from 'flow/contexts/app-context';
import InviteColleague from 'flow/components/invite/InviteColleague';
import { navigateBack } from 'flow/actions/navigate-actions';
import { inviteExternalContact } from 'flow/actions/contact-actions';
import { jsx as _jsx } from "react/jsx-runtime";
var InviteColleagues = /*#__PURE__*/function (_React$PureComponent) {
  function InviteColleagues(props) {
    var _this;
    _classCallCheck(this, InviteColleagues);
    _this = _callSuper(this, InviteColleagues, [props]);
    _defineProperty(_this, "handleInviteExternalContact", function () {
      var inviteContact = _this.props.inviteContact;
      var number = _this.state.number;
      var parsedNumber = parsePhoneNumberFromString(number);
      var validMobileNumber = parsedNumber && parsedNumber.isValid() ? number : null;
      var countryCode = parsedNumber && parsedNumber.isValid() ? parsedNumber.country : '';
      var NumberDTO = {
        number: validMobileNumber,
        countryCode: countryCode
      };
      var invitationDTO = {
        number: NumberDTO
      };
      inviteContact(invitationDTO);
      _this.setState({
        number: ''
      });
    });
    _defineProperty(_this, "handleUpdateNumber", function (number) {
      _this.setState({
        number: number
      });
      _this.props.setNumber(number);
    });
    _this.state = {
      number: ''
    };
    return _this;
  }
  _inherits(InviteColleagues, _React$PureComponent);
  return _createClass(InviteColleagues, [{
    key: "render",
    value: function render() {
      var number = this.state.number;
      return /*#__PURE__*/_jsx(InviteColleague, {
        number: number,
        updateNumber: this.handleUpdateNumber
      });
    }
  }]);
}(React.PureComponent);
_defineProperty(InviteColleagues, "propTypes", {
  inviteContact: PropTypes.func.isRequired,
  setNumber: PropTypes.func.isRequired
});
_defineProperty(InviteColleagues, "contextType", AppContext);
var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  var location = props.location;
  return {
    inviteContact: function inviteContact(invitationDTO) {
      return dispatch(inviteExternalContact(invitationDTO));
    },
    handleExit: function handleExit() {
      return dispatch(navigateBack(location));
    }
  };
};
export default connect(mapDispatchToProps)(InviteColleagues);